module.exports = __webpack_public_path__ + "img/bug.e4158bed.png";